class NavScroller {
    constructor() {
        this.dom = {};
        this.dom.win = window;  
        this.dom.scrollerSection = document.querySelector('.navscroller-section'); // the outer section for styles (border, scroll top)
        this.dom.menuContainer = document.querySelector('.navscroller__menu-container'); // the menu-container (for ul below)
        this.dom.scrollerMenu = document.querySelector('.navscroller-menu'); // the real menu <ul> - needed for widths
        this.dom.scrollLeftButton = document.querySelector('.navscroller__scroll-left-btn'); // btn
        this.dom.scrollRightButton = document.querySelector('.navscroller__scroll-right-btn'); // btn
    }


    // Helper Debouncs (for resize)
    // Returns a function, that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds. If `immediate` is passed, trigger the function on the
    // leading edge, instead of the trailing.
    debounce(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    // Update scroll buttons according to current scroll position
    updateScrollBtns = () => {

        const container = this.dom.menuContainer;

        const scrollLeft = container.scrollLeft;
        const maxScrollLeft = container.scrollWidth - container.clientWidth;

        // Tolerance for fractional pixel values
        const tolerance = 2;

        const atStart = scrollLeft <= tolerance;
        const atEnd = scrollLeft >= maxScrollLeft - tolerance;

        const updateButton = (button, disabled) => {
            button.disabled = disabled;
            button.classList.toggle('is-hidden', disabled);
        };

        updateButton(this.dom.scrollLeftButton, atStart);
        updateButton(this.dom.scrollRightButton, atEnd);
    };

    // Update button states on load and resize
    setBtns = () => {
        this.updateScrollBtns();
    };


    addListeners() {

        if (this.dom.scrollerSection) {

            this.dom.scrollLeftButton.addEventListener('click', () => {
                // Scroll by a fixed amount or the width of one item
                this.dom.menuContainer.scrollBy({
                    left: -200, // Adjust scroll amount as needed
                    behavior: 'smooth'
                });
            });

            this.dom.scrollRightButton.addEventListener('click', () => {
                // Scroll by a fixed amount or the width of one item
                this.dom.menuContainer.scrollBy({
                    left: 200, // Adjust scroll amount as needed
                    behavior: 'smooth'
                });
            });

            // Update button states when the navigation scrolls
            this.dom.menuContainer.addEventListener('scroll', () => {
                this.updateScrollBtns();
            }, { passive: true });

            this.dom.win.addEventListener('scroll', () => {
                // console.log(menuContainer.getBoundingClientRect());
                if (this.dom.scrollerSection.getBoundingClientRect().top <= 0) {
                    // items top has reached beyond window top
                    this.dom.scrollerSection.classList.add('is-top');
                    this.dom.scrollerSection.classList.remove('--border-none');
                
                } else {
                    this.dom.scrollerSection.classList.remove('is-top');
                    this.dom.scrollerSection.classList.add('--border-none');
                }

            });

            // Keep focused navigation links visible when navigating by keyboard
            this.dom.scrollerMenu.addEventListener('focusin', (event) => {

                const link = event.target.closest('.navscroller-link');

                if (!link) return;

                const container = this.dom.menuContainer;

                const containerRect = container.getBoundingClientRect();
                const linkRect = link.getBoundingClientRect();

                // Visible area between the two scroll buttons
                const buttonWidth = this.dom.scrollLeftButton.getBoundingClientRect().width;

                const visibleLeft = containerRect.left + buttonWidth;
                const visibleRight = containerRect.right - buttonWidth;

                let scrollAmount = 0;

                if (linkRect.left < visibleLeft) {
                    scrollAmount = linkRect.left - visibleLeft;

                } else if (linkRect.right > visibleRight) {
                    scrollAmount = linkRect.right - visibleRight;
                }

                if (scrollAmount !== 0) {
                    container.scrollBy({
                        left: scrollAmount,
                        behavior: 'instant'
                    });
                }
            });

            this.dom.win.addEventListener('load', this.setBtns);
            this.dom.win.addEventListener('resize', this.debounce(this.setBtns, 200)); // apply 200 ms OR test yourself
        }
    }

    init() {
        this.addListeners();
    }
}

export default NavScroller;
